import { render } from "./show-images-in-vue.vue?vue&type=template&id=4d245720"
import script from "./show-images-in-vue.vue?vue&type=script&lang=js"
export * from "./show-images-in-vue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__